export class SlBrand {
  static colors = {
    LuluSoft: {
      fill: '#7290BB',
      fillD: '#98B2D9',
      bcg: '#D7EBFE',
      fillErr: '#FF3D41',
      bcgErr: '#FFEBEC',
      pointerNormal: '#4D82B8',
      pointerMissed: '#FF6366',
      progress: '#0072C6',
      textCopySelection: '#80D7EBFE',
      bgcArrow: '#068adf',
      selectedBgcIconAreaField: '#057cc8',
      bgcSignatureAndInitial: '#068ADE1A',
      bgcBtnAction: '#068ADE',
    },
    PdfForge: {
      fill: '#F1BC56',
      fillD: '#C88D00',
      bcg: '#FFE7B1',
      fillErr: '#F00000',
      bcgErr: '#FFD9DA',
      pointerNormal: '#5BBFDE',
      pointerMissed: '#F00000',
      progress: '#F00000',
      textCopySelection: '#80FFE7B1',
      bgcArrow: '#FFAE40',
      selectedBgcIconAreaField: '#FF9900',
      bgcSignatureAndInitial: '#FFF5DF',
      bgcBtnAction: '#E51800',
    },
    ExpertPDF: {
      fill: '#7E9B75',
      fillD: '#A6C29E',
      bcg: '#CDE3CB',
      fillErr: '#EC4E51',
      bcgErr: '#FFEBEC',
      pointerNormal: '#5F9752',
      pointerMissed: '#E08284',
      progress: '#2EA015',
      textCopySelection: '#80D2E8D0',
      bgcArrow: '#33B217',
      selectedBgcIconAreaField: '#379B21',
      bgcSignatureAndInitial: '#33B21733',
      bgcBtnAction: '#33B217',
    },
  };

  constructor() {}
}
